import React, { useState, useEffect } from 'react';
import Page from 'components/Templates/Page';
import Msg from 'components/Msg';
import BtnTitle from 'components/BtnTitle';
import Fieldset from 'components/Fieldset';
import Button from 'components/Button';
import api from 'services/api';
import FieldSelect from 'components/FieldSelect';
import { useHistory } from "react-router-dom";
import Switch from 'components/Switch';
import Voucher from 'voucher-code-generator';

import './style.css';

export default function AddSeller() {

    const history = useHistory();

        
    const [name, setname] = useState('')
    const [email, setemail] = useState('')
    const [code, setcode] = useState('')
    const [saleProfile, setsaleProfile] = useState('')
    const [region, setregion] = useState('')
    const [permitedSonSeller, setpermitedSonSeller] = useState(false)
    const [parentId, setparentId] = useState('')
    
    const [saleProfiles, setSaleProfiles] = useState([]);


    const [isLoading, setIsLoading] = useState(false);
    const [msg, setMsg] = useState({ message: '', type: '' });



    useEffect(() => {
        if(name.length === 0 ){
            const loadSaleProfiles = async () => {
                const response = await api.get(`admin/ondemand/sale-profiles`);
                setSaleProfiles(response.data);
            }
            loadSaleProfiles();
        }

        // Generate code
        let code = name.slice(0, 3);
        if (name.length >= 3) {
            const voucher = Voucher.generate({
                length: 3,
                count: 1,
                prefix: code
            });

            setcode(voucher[0].toUpperCase())
            
        }

    }, [name]);



    const add = async () => {

        setIsLoading(true);

        try {
            await api.post('/admin/ondemand/sellers', { 
                name,
                email,
                code,
                saleProfile,
                region,
                permitedSonSeller,
                parentId
             });
            setIsLoading(false);
            setMsg({ message: 'Vendedor adicionado com sucesso.', type: 'success' });
            
            setname('')
            setemail('')
            setcode('')
            setsaleProfile('')
            setregion('')
            setpermitedSonSeller(false)
            setparentId('')

        } catch (error) {
            setIsLoading(false);
            if (error.response?.data.msg) {
                const msg = error.response.data.msg;
                setMsg({ message: msg, type: 'error' });
                return;
            }
            setMsg({ message: 'Falha de conexão.', type: 'error' });
        }
    }

    


    return (
        <Page name="sales">
            <h1>
                Adicionar Vendedor
                <BtnTitle label="Voltar" iconName="chevron-left" handleOnClick={() => history.goBack()} />
            </h1>


            <div className="informacoes">

                <div className="container">
                    <h3>Informações</h3>
                    <FieldSelect label="Perfil de Venda" handleValue={saleProfile} handleOnChange={(e) => setsaleProfile(e.target.value)}>
                        <option value="">Selecione</option>
                        {
                            saleProfiles.map((item, index) => (
                                <option key={index} value={item._id}>{item.name}</option>
                            ))
                        }
                    </FieldSelect>

                    <Fieldset label="Nome" type="text" placeholder="Digite um nome para o perfil." handleValue={name} handleOnChange={(e) => setname(e.target.value)} />
                    <Fieldset label="Código Vendedor" type="text" placeholder="" handleValue={code} handleOnChange={(e) => setcode(e.target.value)} />
                    <Fieldset label="E-mail" type="text" placeholder="" handleValue={email} handleOnChange={(e) => setemail(e.target.value)} />
                    <Fieldset label="Região" type="text" placeholder="" handleValue={region} handleOnChange={(e) => setregion(e.target.value)} />
                    <hr/>
                    <Switch text="Permitir que o esse vendedor cadastre vendedores filhos?" handleChange={setpermitedSonSeller} handleChecked={permitedSonSeller}  />
                    
                    
                    
                </div>

            </div>

            { msg.message ? <Msg type={msg.type} message={msg.message} /> : null}

            <div className="areaBtnPlan">
                <Button label="Adicionar Vendedor" isLoading={isLoading} handleOnClick={add} handleType="submit" />
            </div>

        </Page>
    )
}
